import React from 'react';
import { Card } from 'semantic-ui-react';
import clsx from 'clsx';

const CardItem = ({
  active,
  children,
  className,
  error,
  warning,
}) => (
  <Card
    className={clsx(
      'aridhia-card-item panel-no-focus',
      className,
      error ? 'error' : null,
      active ? 'active' : null,
      (warning && !error) ? 'warning' : null,
    )}
    raised
  >
    {children}
  </Card>
);

export default CardItem;
